import { SignaturePositions } from '../../models';
import { generateBranding } from './generateBranding';
import { generateLogo } from './generateLogo';
function generateSignatureHtml(formData, signatureHtml) {
    if (formData.signature_position === SignaturePositions.HIDE || !signatureHtml) {
        return '';
    }
    if (formData.signature_position === SignaturePositions.LEFT || formData.signature_position === SignaturePositions.RIGHT) {
        return /* html */ `
      <div style="float:${formData.signature_position};margin-bottom:20px;">
        ${signatureHtml}
      </div>
    `;
    }
    return /* html */ `
    <div style="display:flex;justify-content:center;margin-bottom:20px;">
      <div>
        ${signatureHtml}
      </div>
    </div>
  `;
}
export function generateEmailBody(formData, logoUrl, removeBranding, signatureHtml) {
    return /* html */ `
    <body>
    <center class="wrapper" data-link-color="#1188E6"
      data-body-style="font-size:14px; font-family:arial,helvetica,sans-serif; color:#000000; background-color:#FFFFFF;">
      <div class="webkit">
        <table cellpadding="0" cellspacing="0" border="0" width="100%" height="100%" class="wrapper" bgcolor="#FFFFFF">
          <tr>
            <td valign="top" bgcolor="#FFFFFF" width="100%">
              <table width="100%" role="content-container" class="outer" align="center" cellpadding="0" cellspacing="0"
                border="0"
                >
                <tr>
                  <td width="100%">
                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td>
                          <!--[if mso]>
      <center>
      <table><tr><td width="600">
    <![endif]-->
                          <table width="100%" cellpadding="0" cellspacing="0" border="0"
                            style="width:100%; max-width:600px;" align="center">
                            <tr>
                              <td role="modules-container"
                                style="padding:0px 20px 0px 20px; color:#000000; text-align:left;" bgcolor="#FFFFFF"
                                width="100%" align="left">
                                <table class="module preheader preheader-hide" role="module" data-type="preheader"
                                  border="0" cellpadding="0" cellspacing="0" width="100%"
                                  style="display: none !important; mso-hide: all; visibility: hidden; opacity: 0; color: transparent; height: 0; width: 0;">
                                  <tr>
                                    <td role="module-content">
                                      <p></p>
                                    </td>
                                  </tr>
                                </table>
                                <table class="module" role="module" data-type="spacer" border="0" cellpadding="0"
                                  cellspacing="0" width="100%" style="table-layout: fixed;"
                                  data-muid="78426392-2170-4c39-9596-592c3a8ebcc1">
                                  <tbody>
                                    <tr>
                                      <td style="padding:0px 0px 10px 0px;" role="module-content" bgcolor="">
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                ${generateLogo(logoUrl)}
                                <table class="module" role="module" data-type="spacer" border="0" cellpadding="0"
                                  cellspacing="0" width="100%" style="table-layout: fixed;"
                                  data-muid="78426392-2170-4c39-9596-592c3a8ebcc1.1">
                                  <tbody>
                                    <tr>
                                      <td style="padding:0px 0px 10px 0px;" role="module-content" bgcolor="">
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table class="module" role="module" data-type="text" border="0" cellpadding="0"
                                  cellspacing="0" width="100%" style="table-layout: fixed;"
                                  data-muid="d9cc529a-29d6-429b-8f51-10f40aac4e0e" data-mc-module-version="2019-10-22">
                                  <tbody>
                                    <tr>
                                      <td style="padding:18px 0px 18px 0px; line-height:16px; text-align:inherit;"
                                        height="100%" valign="top" bgcolor="" role="module-content">
                                        <div>
                                          ${formData.main_html_content}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                                <table class="module" role="module" data-type="spacer" border="0" cellpadding="0"
                                  cellspacing="0" width="100%" style="table-layout: fixed;"
                                  data-muid="69ad41f0-53f9-4e59-b8b8-676f4db962c3">
                                  <tbody>
                                    <tr>
                                      <td style="padding:0px 0px 50px 0px;" role="module-content" bgcolor="">
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                                ${generateSignatureHtml(formData, signatureHtml)}

                                ${removeBranding ? `` : generateBranding()}
                                <div data-role="module-unsubscribe" class="module" role="module" data-type="unsubscribe"
                                  style="color:#ffffff; font-size:12px; line-height:20px; padding:16px 16px 16px 16px; text-align:Center;"
                                  data-muid="4e838cf3-9892-4a6d-94d6-170e474d21e5">
                                  <div class="Unsubscribe--addressLine"></div>
                                  <p style="font-size:12px; line-height:20px;"><a target="_blank"
                                      class="Unsubscribe--unsubscribeLink zzzzzzz" href="{{{unsubscribe}}}"
                                      style="color:#ffffff;">Unsubscribe</a></p>
                                </div>
                              </td>
                            </tr>
                          </table>
                          <!--[if mso]>
                                    </td>
                                  </tr>
                                </table>
                              </center>
                              <![endif]-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </center>
  </body>
  `;
}
//# sourceMappingURL=generateEmailBody.js.map